const TD = ({ children, e, title, onClick, style }) => {
  return (
    <>
      <td
        nowrap="nowrap"
        onClick={onClick}
        style={{
          ...style,
          maxWidth: "250px",
          overflow: "hidden", // This will hide any content that overflows the element's box
          textOverflow: "ellipsis", // This will add an ellipsis (...) where the text is cut off
          whiteSpace: "nowrap", // This will prevent the text from wrapping
          // textAlign: typeof content === "number" ? "right" : "left",
        }}
      >
        {children}
      </td>
    </>
  );
};

export default TD;
